import { render } from "./NewInvoiceView.vue?vue&type=template&id=44461238"
import script from "./NewInvoiceView.vue?vue&type=script&lang=js"
export * from "./NewInvoiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__